"use strict";const e=require("styled-components").css`
    text-decoration: none;
    border-radius: 2px;
    outline: none;
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 0.5em;
    align-items: center;
    width: max-content;
    cursor: pointer;
    transition: all 0.4s ease-in-out;
    color: currentColor;
    background: none;
    border: none;
    padding-left: 0;

    > svg {
        height: 0.92em;
        width: auto;
        transition: all 0.4s ease-in-out;
        transform: ${({isReversed:e})=>e?"rotate(180deg)":"none"};

        path {
            fill: currentColor;
        }
    }

    &:hover,
    &:active,
    &:focus {
        svg {
            transform: ${({isReversed:e})=>e?"rotate(180deg) translateX(5px)":"translateX(5px)"};
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
